<template>
    <div class="card shadow">
        <div class="card-header text-center bg-primary">
            Dernières erreurs "Je Declare"
        </div>
        <div class="card-body p-0">
            <div class="notices-container">
                <div v-if="notices.length > 0">
                    <jdc-card
                        v-for="notice in notices"
                        :key="'jdc' + notice.id"
                        :notice="notice"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JdcCard from './JdcCard.vue'

export default {
    name: 'HomeNewJdc',

    components: { JdcCard },

    data() {
        return {
            notices: [],
        }
    },

    async created() {
        await this.getNotices()
    },

    methods: {
        async getNotices() {
            try {
                const response = await this.$axios.get('/jdc/home')
                this.notices = response.data.data
            } catch (error) {
                error.log(error)
            }
        },
    },
}
</script>

<style scoped>
.notices-container {
    background-color: white !important;
    padding: 15px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 562px;
}
</style>
